import { device } from '@ui-components/breakpoints';
import { fontWeightBold, fontWeightRegular, regularWhite } from '@ui-components/design-tokens';
import { playFontSize } from '@ui-components/typography/helpers';
import PlayText from '@ui-components/typography/PlayText';
import styled from 'styled-components';

export const StyledCastAndCrew = styled.section`
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    margin-top: 30px;

    @media ${device.GteSmall} {
        margin-top: 10px;
        margin-bottom: 50px;
    }
`;

export const CastAndCrewLists = styled.div`
    display: block;
    column-count: 1;

    @media ${device.GteSmall} {
        column-count: 2;
    }
`;

export const CastAndCrewSection = styled.div`
    padding-top: 0.9em;
    page-break-inside: avoid;
    break-inside: avoid;
`;

export const CastAndCrewLink = styled.a`
    text-decoration: underline;
    text-underline-position: under;
    ${playFontSize(1.7)}
    color: ${regularWhite};
`;

export const CastAndCrewUl = styled.ul`
    padding: 0;
    margin: 0;
    line-height: 1.6;
    list-style-type: none;
`;

export const CastAndCrewHeading = styled.h2`
    ${playFontSize(2)}
    font-weight: ${fontWeightRegular};
    color: ${regularWhite};
    margin-bottom: 10px;
`;

export const ListHeading = styled.h3`
    ${playFontSize(1.4)}
    color: ${regularWhite};
    font-weight: ${fontWeightBold};
    text-transform: uppercase;
    margin-bottom: 5px;
`;

export const Name = styled(PlayText)`
    ${playFontSize(1.7)}
    color: ${regularWhite};
`;
